export default __webpack_public_path__ + "static/media/logo-app.c6319f23.png";